import { jsx as _jsx } from "react/jsx-runtime";
import { CheckboxGroup as HeroCheckboxGroup } from '@heroui/react';
export const CheckboxGroup = (props) => {
    return _jsx(HeroCheckboxGroup, { ...props });
};
export default CheckboxGroup;
//# sourceMappingURL=CheckboxGroup.js.map